import React, { useState } from 'react';
import { useLoaderData } from 'react-router';
import {
  Box,
  Hidden,
  PageBlock,
  Text,
  Tiles,
  ToastProvider,
} from 'braid-design-system';
import type { DriverList } from './components/QueryFilter';
import { useTargetBlank } from '../../shared/hooks/useTargetBlank';
import { CMSUProvider } from '@seek/cmsu-components/src/hooks/useCMSUContext';
import { useConfig } from '../../shared/hooks';
import { PageLayout } from '../../components/PageLayout/PageLayout';
import type { LayoutProps } from '../../shared/types';
import { QueryFilterForm } from './components/QueryFilterForm';
import { dataLabHelper, type DatalabSurvey } from './datalabHelper';
import { QueryFilterDrawer } from './components/QueryFilterDrawer';
import { ShareDropdown } from './components/ShareDropdown/ShareDropdown';

// TODO!: Replace with actual page title
const pageTitle = 'Talent Attraction Lab';
const layoutProps: LayoutProps = {
  title: 'Loading...',
};

export const Datalab = () => {
  useTargetBlank();
  // Get the params from context.
  const {
    // melwaysLocale, fullURL, sourceName, privacyUrl, country,
    fullURL,

    language,
  } = useConfig();

  const { queryFilters, surveyResults: surveyResult } =
    useLoaderData() as DatalabSurvey;

  const driverList: DriverList = dataLabHelper.getDriverListFrom(queryFilters);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);

  return (
    <PageLayout
      layoutProps={{
        ...layoutProps,
        title: pageTitle,
      }}
    >
      <CMSUProvider config={{ language }}>
        <ToastProvider>
          <PageBlock width="large">
            <Box paddingY="large">
              <Tiles columns={{ mobile: 1, tablet: 2 }} space="xsmall">
                <Hidden below="tablet">
                  <Box>
                    <QueryFilterForm
                      driverList={driverList}
                      showDrawerFilter={showFilterDrawer}
                    />
                  </Box>
                </Hidden>
                <Box>
                  {
                    // ToDo: Replace wtih Driver Summary
                  }
                  <Text>Survey Respondents: {surveyResult.respondents}</Text>
                  <Box>
                    <ShareDropdown pageUrl={fullURL} title={pageTitle} />
                  </Box>
                </Box>
              </Tiles>
            </Box>
            <QueryFilterDrawer
              driverList={driverList}
              setShowFilterDrawer={setShowFilterDrawer}
              showFilterDrawer={showFilterDrawer}
            />
          </PageBlock>
        </ToastProvider>
      </CMSUProvider>
    </PageLayout>
  );
};
